import React, { useState } from 'react';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import campaignService from '../../../services/campaignService';
import authService from '../../../services/authService';
import { convertToFormData } from '../../../helpers/common';
import { StepsFormWrap } from './CreateCompaign.styles';
import { useContextHook } from 'use-context-hook';
import { CampaignAnalyticsContext } from '../../../Context/getCampaignName';
import { useLocation } from 'react-router-dom';
import SmallEditor from './SmallEditor';
const Step5 = ({
  setData,
  data,
  NextStep,
  setStep,
  setActiveTab,
}) => {
  const location = useLocation();
  const { campaign_id } = location?.state || {};
  const campaignId = campaign_id;
  const [loading, setLaoding] = useState(false);
  const { campaignName: contextCampaignName } = useContextHook(CampaignAnalyticsContext, v => ({
    campaignName: v.campaignName,
  }));

  const hanldeSubmit = async () => {
    try {
      setLaoding(true);

      const signature = data?.step5?.signature;

      if (data?.leads_type === 'houdiny_leads') {
        const payload = {
          signature,
          isEnrichment: data?.step2?.isEnrichment || data.isEnrichment,
          task_id: data?.step1?.task_id || data?.task_id,
          campaignId: data?.campaignId || data?.step6?.campaignId,
        };

        const resp = await campaignService.addCampaignEnrichment(payload);

        if (resp.success) {
          Toast({ type: 'success', message: resp.message });

          setData(prev => ({ ...prev, step5: { ...(prev.step5 || {}), signature } }));

          NextStep();

        }
      } else {
        const payload = {
          agentId: 2,
          task_name: data?.step1?.campaign_name || contextCampaignName || data?.task_name,
          analysis_prompt: 'analysis_prompt.txt',
          col_map_analysis: data?.step2?.col_map_analysis,
          msg1_location_map: { 'Company Country': 'Location' },
          ...data?.campaignSettings,
          has_full_name: false,
          ...data?.step4,
          input_csv: data?.step1?.csvfile,
          numOfLeads: data?.step1?.rowLenght,
          agent_type: 'email',
          email_length_msg1: data?.campaignSettings?.email_length_msg1?.value,
          email_length_msg2: data?.campaignSettings?.email_length_msg2?.value,
          email_length_msg3: data?.campaignSettings?.email_length_msg3?.value,
          signature,
          isEnrichment: true,
          campaignId: data?.step2?.campaignId || data?.step6?.campaignId || data?.campaignId || campaignId,
          task_type: 'campaign',
        };
        const formData = convertToFormData(payload);
        const res = await authService.creatTask(formData);
        if (res.success) {
          Toast({ type: 'success', message: 'Campaign task created successfully' });
          setData(prev => ({ ...prev, step5: { ...(prev.step5 || {}), signature, isEnrichment: true } }));
          setStep(6);
        }
      }
    } catch (error) {
      Toast({ type: 'error', message: error.message });
    } finally {
      setLaoding(false);
    }
  };

  const handleNextClick = () => {
    const raw = data?.step5?.signature || '';

    const hasImage = /<img[^>]*src=["']([^"']+)["'][^>]*>/i.test(raw);
    const cleaned = raw
      .replace(/<img[^>]*>/gi, '') // ignore images when checking text
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim();

    if (!hasImage && !cleaned) {
      const message = 'Signature is required';
      Toast({ type: 'error', message });
      return;
    }

    hanldeSubmit();
  };

  return (
    <>
      <StepsFormWrap>
        <div className="content-wrap">
          <div className="head">
            <div>
              <span className="heading">Signature Info!</span>
              <p>Upload your e-signatures</p>
            </div>
          </div>

          <SmallEditor
            value={data?.step5?.signature}
            onChange={e =>
              setData(prev => ({
                ...prev,
                step5: { ...(prev.step5 || {}), signature: e.target.value },
              }))
            }
          />

        </div>


        <div className="btn-holder">

          <Button newStyle rounded variant="outline" width="155px" type="button" onClick={() => setActiveTab('tone')}>
            Back
          </Button>
          <Button
            newStyle
            rounded
            variant="darkBlue"
            type="button"
            width="155px"
            loader={loading}
            disabled={loading}
            onClick={handleNextClick}>
            Next
          </Button>
        </div>
      </StepsFormWrap>
    </>
  );
};

export default Step5;
